module.exports = __webpack_public_path__ + "img/project12_2.png.d46e7b0d.webp";